<template>
  <v-dialog v-model="open" :width="$vuetify.breakpoint.xs ? '80%' : '50%'" persistent>
    <v-card class="confirm-dialog pa-2">
      <v-card-text>
        <v-icon v-if="icon" class="icon" color="success ">check_circle</v-icon>
        <p class="confirm-title text-xs-center">{{ title }}</p>
        <p class="confirm-message text-xs-center">{{ message }}</p>
        <p class="confirm-undertext text-xs-center">{{ underText }}</p>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn class="button-height" large :color="confirmColor" :dark="dark" @click.stop="onConfirm()">{{ confirmText }}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  }
}
</script>
<style lang="scss">
.confirm-dialog {
  .confirm-title {
    font-size: 32px;
    opacity: 0.84;
  }
  .confirm-message {
    font-size: 18px;
    opacity: 0.54;
    margin-bottom: 0px;
  }
  .confirm-undertext {
    font-size: 18px;
    opacity: 0.54;
    font-weight: bold;
  }
  .icon {
    display: flex;
    font-size: 80px;
    margin-bottom: 16px;
  }
}
</style>
